import React from 'react';
import { Checkbox } from 'antd';
import * as echarts from 'echarts';
import 'echarts/lib/chart/scatter';
import 'echarts/lib/component/dataZoom';
import 'echarts/lib/component/tooltip';

import style from './ScatterChart.module.scss';

export default class ScatterChart extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            record: props.record,
            dataList: props.dataList || [],
            topTimeList: (props.optResult?.result?.kpi_result?.top_state_datetime ?? [])
                .map(item => ({ value: item[0], checked: true }))
        };

        this.option = {
            tooltip: { trigger: 'axis' },
            grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                top: '3%',
                containLabel: true
            },
            xAxis: { scale: true },
            yAxis: { scale: true },
            series: [{
                symbolSize: 5,
                data: [],
                type: 'scatter',
                markArea: {
                    data: [[
                        { name: '推荐区间', xAxis: 0 },
                        { xAxis: 0 }
                    ]],
                    itemStyle: {
                        color: ['rgba(238, 246, 225, 1)', 'rgba(238, 246, 225, 1)'],
                        borderType: 'dashed',
                        borderColor: '#008080',
                        borderWidth: 1,
                        opacity: 0.5
                    }
                }
            }]
        };

        this.chartInstance = null;
    }

    componentDidMount() {
        if (this.chartNode) {
            this.chartInstance = echarts.init(this.chartNode);
            this.updateChart();
        }
    }

    componentDidUpdate(prevProps, prevState) {

        const dataChanged =
            prevProps.dataList !== this.props.dataList;

        const recordChanged =
            prevProps.record !== this.props.record;

        if (dataChanged || recordChanged) {
            this.setState({
                record: this.props.record,
                dataList: this.props.dataList || []
            }, () => this.updateChart());
        }
    }

    componentWillUnmount() {
        if (this.chartInstance) {
            this.chartInstance.dispose();
            this.chartInstance = null;
        }
    }

    updateChart = () => {
        if (!this.chartInstance) return;

        const record = this.state.record;
        const xkey = record?.scatter_plotxy?.[0];
        const ykey = record?.scatter_plotxy?.[1];

        this.option.series[0].data = (this.state.dataList || []).map(item => [
            item[xkey],
            item[ykey]
        ]);

        const areaItem = this.option.series[0].markArea.data[0];
        areaItem[0].xAxis = record?.bound_low;
        areaItem[1].xAxis = record?.bound_high;

        this.chartInstance.clear();
        this.chartInstance.setOption(this.option);
    }

    onChangeTime = (checked, item) => {
        item.checked = checked;

        this.setState({
            topTimeList: [...this.state.topTimeList]
        });
    }

    render() {
        const r = this.state.record;

        return (
            <div className={style["PA_ScatterChart"]}>
                <div className="left-content">

                    <div className="info-bar">
                        <div>参数名称：<b>{r?.name}</b></div>
                        <div>当前值：{r?.curValue}</div>
                        <div>推荐区间：{r?.bound_low} ~ {r?.bound_high}</div>
                    </div>

                    <div
                        className="scatter-node"
                        ref={node => this.chartNode = node}
                    />
                </div>

                <div className="time-options">
                    {this.state.topTimeList.map((item, idx) => (
                        <Checkbox
                            key={idx}
                            checked={item.checked}
                            onChange={e => this.onChangeTime(e.target.checked, item)}
                        >
                            {item.value}
                        </Checkbox>
                    ))}
                </div>
            </div>
        );
    }
}